import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookingDurationService {
  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  getAllByOrganization(filter: any): any {
    return this.http.get(`${this.url}/bookingdurations/organization`, { params: filter });
  }

  createStandardDurations(data: any): any {
    return this.http.post(`${this.url}/bookingduration/create/standard`, data);
  }

  create(data: any): any {
    return this.http.post(`${this.url}/bookingduration/create`, data);
  }
  
  update(id: string, data: any): any {
    return this.http.post(`${this.url}/bookingduration/update/${id}`, data);
  }

  delete(data: any): any {
    return this.http.post(`${this.url}/bookingduration/delete`, data);
  }
}